export const profile = {
  name: 'Yerke Massainov',
  role: 'Full-Stack Developer & Computer Science Graduate Applicant',
  headline: 'Building thoughtful software at the intersection of AI, data, and human-centered systems.',
  summary:
    "I'm a computer science applicant focused on full-stack development, AI-assisted products, data visualization, and human-computer interaction.",
  location: 'United States',
  email: 'erkebulanmassainovvv@gmail.com',
  github: 'https://github.com/NeVajnoKak',
  linkedin: 'https://www.linkedin.com/in/yerke-massainov/',
  resumeUrl: '/CV_Yerke.pdf'
}
